module.exports = __webpack_public_path__ + "static/media/download_src_1.17707070.jpg";